/*!
=========================================================
* Black Dashboard React v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState, useRef } from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  FormGroup,
  Form,
  Input,
  Label,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Badge,
  Progress,
} from "reactstrap";
import { useHistory } from "react-router-dom";
import { logApp } from "utils/func";
import axios from "axios";
import { API_TIMEOUT } from "utils";
import swal from "sweetalert";
import { API_DONOR_DARAH } from "utils";

function EdukasiPendonor() {
  const [currentUser, setCurrentUser] = useState("");
  const history = useHistory();

  // State untuk form pesan edukasi
  const [topik, setTopik] = useState("");
  const [judul, setJudul] = useState("");
  const [isiPesan, setIsiPesan] = useState("");
  const [listEdukasi, setListEdukasi] = useState([]);
  const [selectedEdukasi, setSelectedEdukasi] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  // State untuk golongan darah
  const [listGolda, setListGolda] = useState([]);
  const [selectedGolda, setSelectedGolda] = useState("");
  const [selectedGoldaName, setSelectedGoldaName] = useState("");

  // State untuk WhatsApp
  const [modalWhatsAppOpen, setModalWhatsAppOpen] = useState(false);
  const [modalPilihGoldaOpen, setModalPilihGoldaOpen] = useState(false);
  const [listPendonor, setListPendonor] = useState([]);
  const [draftPesan, setDraftPesan] = useState("");
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
  const [progressWhatsApp, setProgressWhatsApp] = useState({
    current: 0,
    total: 0,
  });
  const [detailPengiriman, setDetailPengiriman] = useState([]);
  const cancelSendingRef = useRef(false);
  const [wablasConfig, setWablasConfig] = useState({
    url: "",
    tokenwhatsapp: "",
    secret_key: "",
  });
  const [currentBatchIndex, setCurrentBatchIndex] = useState(0);
  const [allBatches, setAllBatches] = useState([]);
  const [batchProgress, setBatchProgress] = useState({ current: 0, total: 0 });

  // Fungsi delay untuk menghindari rate limiting
  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // Fungsi untuk membatalkan pengiriman
  const handleCancelSending = () => {
    cancelSendingRef.current = true;
    setSendingWhatsApp(false);
    swal(
      "Dibatalkan",
      `Pengiriman pesan dibatalkan. ${progressWhatsApp.current} dari ${progressWhatsApp.total} pesan sudah terkirim.`,
      "info"
    );
  };

  useEffect(() => {
    getWablasConfig();
    getListEdukasi();
    getListGolda();
    // Jika data yang disimpan di localStorage adalah dalam format JSON, Anda perlu menguraikannya menjadi objek
    if (!currentUser) {
      let user = localStorage.getItem("user");
      if (user) {
        user = JSON.parse(user);
        setCurrentUser(user);
        logApp(user.uid, "Edukasi Pendonor");
      } else {
        history.push("/login");
      }
    }
  }, []);

  // Fungsi untuk mengambil konfigurasi wablas aktif
  const getWablasConfig = async () => {
    try {
      const response = await axios.get(`${API_DONOR_DARAH}wablas/active`, {
        timeout: API_TIMEOUT,
      });

      if (response.data?.success === 1 && response.data.data) {
        setWablasConfig({
          url: response.data.data.url,
          tokenwhatsapp: response.data.data.tokenwhatsapp,
          secret_key: response.data.data.secret_key || "",
        });
      } else {
        console.log("Tidak ada konfigurasi wablas aktif, menggunakan default");
      }
    } catch (error) {
      console.error("Error fetching wablas config:", error);
    }
  };

  // Fungsi untuk mengambil daftar pesan edukasi
  const getListEdukasi = async () => {
    try {
      const response = await axios.get(`${API_DONOR_DARAH}edukasi-pendonor`, {
        timeout: API_TIMEOUT,
      });

      if (response.data?.success && response.data.data) {
        setListEdukasi(response.data.data);
      } else {
        setListEdukasi([]);
      }
    } catch (error) {
      console.error("Error fetching list edukasi:", error);
      // Jika endpoint belum ada atau error, set list kosong
      setListEdukasi([]);

      // Tampilkan error hanya jika bukan 404 (tabel belum dibuat)
      if (error.response) {
        if (error.response.status === 404) {
          console.warn(
            "Endpoint edukasi-pendonor belum tersedia atau tabel belum dibuat"
          );
        } else {
          console.warn(
            "Gagal mengambil daftar edukasi:",
            error.response.data?.message || error.message
          );
        }
      } else if (error.request) {
        // Request was made but no response received
        if (
          error.message === "Failed to fetch" ||
          error.message.includes("Network Error")
        ) {
          console.error(
            "Tidak dapat terhubung ke server. Pastikan backend sudah berjalan dan tabel 'edukasi_pendonor' sudah dibuat."
          );
        }
      }
    }
  };

  // Fungsi untuk mengambil daftar golongan darah
  const getListGolda = async () => {
    var data1 = [];

    try {
      const response = await axios.get(API_DONOR_DARAH + "bloodtypes");
      data1 = response.data.data;

      if (data1.length > 0) {
        // Urutkan: A, B, AB, O tanpa rhesus di atas, kemudian yang dengan rhesus
        const golonganDasar = ["A", "B", "AB", "O"];
        const sorted = data1.sort((a, b) => {
          const golA = a.golonganDarah.split("(")[0].trim();
          const golB = b.golonganDarah.split("(")[0].trim();
          const indexA = golonganDasar.indexOf(golA);
          const indexB = golonganDasar.indexOf(golB);

          // Jika keduanya ada di golongan dasar
          if (indexA !== -1 && indexB !== -1) {
            // Bandingkan index
            if (indexA !== indexB) {
              return indexA - indexB;
            }
            // Jika sama, yang tanpa rhesus di atas
            const hasRhesusA = a.golonganDarah.includes("(");
            const hasRhesusB = b.golonganDarah.includes("(");
            if (hasRhesusA && !hasRhesusB) return 1;
            if (!hasRhesusA && hasRhesusB) return -1;
            return a.golonganDarah.localeCompare(b.golonganDarah);
          }

          // Jika hanya A yang ada di golongan dasar
          if (indexA !== -1) return -1;
          // Jika hanya B yang ada di golongan dasar
          if (indexB !== -1) return 1;
          // Keduanya tidak ada di golongan dasar, urutkan alphabetically
          return a.golonganDarah.localeCompare(b.golonganDarah);
        });

        setListGolda(sorted);
      } else {
        setListGolda([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Fungsi untuk menyimpan pesan edukasi
  const simpanEdukasi = async () => {
    if (!topik || !judul || !isiPesan) {
      swal("Info", "Semua field harus diisi", "error");
      return;
    }

    const data = {
      topik: topik,
      judul: judul,
      isiPesan: isiPesan,
      createdBy: currentUser.uid,
    };

    try {
      let response;
      if (isEditMode && selectedEdukasi) {
        // Update
        response = await axios.put(
          `${API_DONOR_DARAH}edukasi-pendonor/${selectedEdukasi.id}`,
          data,
          {
            timeout: API_TIMEOUT,
          }
        );
      } else {
        // Create
        response = await axios.post(
          `${API_DONOR_DARAH}edukasi-pendonor`,
          data,
          {
            timeout: API_TIMEOUT,
          }
        );
      }

      if (response.status === 200 && response.data?.success) {
        swal(
          "Berhasil",
          `Pesan edukasi berhasil ${isEditMode ? "diupdate" : "disimpan"}`,
          "success"
        );
        resetForm();
        getListEdukasi();
      } else {
        swal(
          "Gagal",
          response.data?.message || "Gagal menyimpan pesan edukasi",
          "error"
        );
      }
    } catch (error) {
      console.error("Error menyimpan edukasi:", error);
      let errorMessage = "Gagal menyimpan pesan edukasi";

      if (error.response) {
        // Server responded with error
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        // Request was made but no response received
        if (error.code === "ECONNABORTED") {
          errorMessage =
            "Request timeout. Server mungkin sedang sibuk atau tidak merespons.";
        } else if (
          error.message === "Failed to fetch" ||
          error.message.includes("Network Error")
        ) {
          errorMessage =
            "Tidak dapat terhubung ke server. Pastikan:\n1. Backend server sudah berjalan\n2. Tabel 'edukasi_pendonor' sudah dibuat di database\n3. Endpoint API sudah tersedia";
        } else {
          errorMessage =
            "Tidak dapat terhubung ke server. Pastikan backend sudah berjalan.";
        }
      } else {
        // Something else happened
        errorMessage = error.message || errorMessage;
      }

      swal("Gagal", errorMessage, "error");
    }
  };

  // Fungsi untuk mengedit pesan edukasi
  const handleEdit = (edukasi) => {
    setSelectedEdukasi(edukasi);
    setTopik(edukasi.topik || "");
    setJudul(edukasi.judul || "");
    setIsiPesan(edukasi.isiPesan || "");
    setIsEditMode(true);
  };

  // Fungsi untuk menghapus pesan edukasi
  const handleDelete = async (id) => {
    const confirm = await swal({
      title: "Hapus Pesan Edukasi?",
      text: "Apakah Anda yakin ingin menghapus pesan edukasi ini?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });

    if (confirm) {
      try {
        const response = await axios.delete(
          `${API_DONOR_DARAH}edukasi-pendonor/${id}`,
          {
            timeout: API_TIMEOUT,
          }
        );

        if (response.status === 200 && response.data?.success) {
          swal("Berhasil", "Pesan edukasi berhasil dihapus", "success");
          getListEdukasi();
        } else {
          swal("Gagal", "Gagal menghapus pesan edukasi", "error");
        }
      } catch (error) {
        console.error("Error menghapus edukasi:", error);
        swal("Gagal", "Gagal menghapus pesan edukasi", "error");
      }
    }
  };

  // Fungsi untuk reset form
  const resetForm = () => {
    setTopik("");
    setJudul("");
    setIsiPesan("");
    setSelectedEdukasi(null);
    setIsEditMode(false);
  };

  // Fungsi untuk generate draft pesan dengan format khusus
  const generateDraftPesan = (edukasi) => {
    const appLink = `https://donor-darah.rotendaokab.go.id`;

    // Format pesan dengan header menyapa nama pendonor, link aplikasi, dan footer
    // Sesuai permintaan: header menyapa nama pribadi, link aplikasi, dan footer dari sistem
    const pesan = `Halo *[Nama Pendonor]*,

🔗 *Aplikasi Donor Darah:*
${appLink}

📚 *${edukasi.judul}*

${edukasi.isiPesan}

Pesan ini dikirimkan dari sistem donor darah Dinas Kesehatan Kab. Rote Ndao

🙏🙏🙏`;

    return pesan;
  };

  // Fungsi untuk mengambil pendonor dan menampilkan modal
  const ambilPendonorDanTampilkanModal = async (
    edukasi,
    bloodTypeID = null
  ) => {
    try {
      // Validasi golongan darah dipilih
      if (!bloodTypeID && !selectedGolda) {
        swal("Info", "Silakan pilih golongan darah terlebih dahulu", "info");
        return;
      }

      const goldaID = bloodTypeID || selectedGolda;

      // Ambil semua data pendonor
      const response = await axios.get(API_DONOR_DARAH + "donatur", {
        timeout: API_TIMEOUT,
      });

      if (response.data?.success && response.data.data) {
        // Ambil info golongan darah yang dipilih
        const selectedBloodType = listGolda.find(
          (bt) => bt.bloodTypeID == goldaID
        );
        const golonganDarahName = selectedBloodType
          ? selectedBloodType.golonganDarah
          : "Golongan Darah";

        // Filter pendonor berdasarkan golongan darah
        // Bandingkan dengan golongan dasar (A, B, AB, O) tanpa rhesus
        const filteredPendonor = response.data.data.filter((donor) => {
          if (!donor.bloodTypes || !donor.noHp) return false;

          // Ambil golongan dasar dari bloodTypes (misal "A(+)" -> "A")
          const donorGolDasar = donor.bloodTypes.split("(")[0].trim();
          const selectedGolDasar = golonganDarahName.split("(")[0].trim();

          return donorGolDasar === selectedGolDasar;
        });

        if (filteredPendonor.length === 0) {
          swal(
            "Info",
            `Tidak ada pendonor dengan golongan darah ${golonganDarahName}`,
            "info"
          );
          return;
        }

        // Generate draft pesan
        const pesan = generateDraftPesan(edukasi);
        setDraftPesan(pesan);
        setListPendonor(filteredPendonor);
        setSelectedEdukasi(edukasi);
        setSelectedGolda(goldaID);
        setSelectedGoldaName(golonganDarahName);

        // Buka modal konfirmasi
        setModalWhatsAppOpen(true);
      } else {
        swal("Info", "Data pendonor tidak ditemukan", "info");
      }
    } catch (error) {
      console.error("Error mengambil data pendonor:", error);
      swal("Error", "Gagal mengambil data pendonor", "error");
    }
  };

  // Fungsi untuk mengirim pesan WhatsApp (dengan batch processing)
  const kirimWhatsApp = async (
    batchIndex = 0,
    isContinue = false,
    batchesData = null
  ) => {
    try {
      console.log("kirimWhatsApp dipanggil", {
        batchIndex,
        isContinue,
        listPendonorLength: listPendonor.length,
        selectedEdukasi: !!selectedEdukasi,
        draftPesan: !!draftPesan,
      });

      if (listPendonor.length === 0 || !selectedEdukasi) {
        swal("Info", "Tidak ada pendonor yang akan dikirimi pesan", "info");
        return;
      }

      if (!draftPesan || draftPesan.trim() === "") {
        swal(
          "Error",
          "Draft pesan tidak ditemukan. Silakan pilih edukasi terlebih dahulu.",
          "error"
        );
        return;
      }

      let batches = batchesData;
      let totalBatchesCount = 0;

      // Setup batches jika mulai dari awal
      if (!isContinue || !batches) {
        const validDonors = listPendonor.filter(
          (donor) => donor.noHp && donor.noHp.trim() !== ""
        );

        if (validDonors.length === 0) {
          swal("Info", "Tidak ada pendonor dengan nomor HP yang valid", "info");
          return;
        }

        // Split menjadi batch maksimal 50
        const BATCH_SIZE = 50;
        batches = [];
        for (let i = 0; i < validDonors.length; i += BATCH_SIZE) {
          batches.push(validDonors.slice(i, i + BATCH_SIZE));
        }

        totalBatchesCount = batches.length;
        setAllBatches(batches);
        setCurrentBatchIndex(0);
        setBatchProgress({ current: 1, total: totalBatchesCount });

        // Jika lebih dari 50 pendonor, tampilkan info
        if (validDonors.length > BATCH_SIZE) {
          const confirm = await swal({
            title: "Peringatan",
            text: `Total ${validDonors.length} pendonor akan dikirimi pesan dalam ${totalBatchesCount} batch (maksimal ${BATCH_SIZE} per batch). Batch pertama akan dikirim sekarang.`,
            icon: "info",
            buttons: {
              cancel: "Batal",
              confirm: "Lanjutkan",
            },
          });

          if (!confirm) {
            return;
          }
        }
      } else {
        totalBatchesCount = batches.length;
      }

      // Ambil batch yang akan dikirim
      const currentBatch = batches[batchIndex];
      if (!currentBatch || currentBatch.length === 0) {
        setSendingWhatsApp(false);
        return;
      }

      setSendingWhatsApp(true);
      cancelSendingRef.current = false;
      setProgressWhatsApp({ current: 0, total: currentBatch.length });
      setBatchProgress({ current: batchIndex + 1, total: totalBatchesCount });

      // Reset detail pengiriman hanya untuk batch pertama
      if (batchIndex === 0) {
        setDetailPengiriman([]);
      }

      // Konfigurasi wablas sekarang diambil langsung oleh backend dari database
      // Tidak perlu dikirim dari frontend untuk keamanan

      let successCount = 0;
      let failCount = 0;
      const validDonors = currentBatch;

      // Array untuk menyimpan detail pengiriman (untuk disimpan ke database)
      const detailPengirimanForDB = [];

      // Check jika pengiriman dibatalkan
      if (cancelSendingRef.current) {
        setSendingWhatsApp(false);
        return;
      }

      // Siapkan data untuk multiple send (API V2)
      const recipients = [];
      const donorMap = new Map(); // Untuk mapping phone -> donor data

      // Format nomor HP dan personalisasi pesan untuk setiap pendonor
      for (let i = 0; i < validDonors.length; i++) {
        const donor = validDonors[i];

        // Format nomor HP
        let phoneNumber = "";
        if (donor.noHp) {
          phoneNumber = donor.noHp.replace(/\D/g, "");
          if (phoneNumber.startsWith("0")) {
            phoneNumber = "62" + phoneNumber.substring(1);
          } else if (!phoneNumber.startsWith("62")) {
            phoneNumber = "62" + phoneNumber;
          }
        }

        if (!phoneNumber) continue;

        // Personalisasi pesan dengan nama pendonor
        let pesanPersonal = draftPesan.replace(
          /Halo \*\[Nama Pendonor\]\*,/g,
          `Halo *${donor.nama || "Bapak/Ibu"}*,`
        );

        // Fallback: jika format lama masih ada
        if (pesanPersonal.includes("Halo Bapak/Ibu,")) {
          pesanPersonal = pesanPersonal.replace(
            "Halo Bapak/Ibu,",
            `Halo *${donor.nama || "Bapak/Ibu"}*,`
          );
        }

        // Tambahkan ke recipients
        recipients.push({
          phone: phoneNumber,
          message: pesanPersonal,
        });

        // Simpan mapping untuk tracking
        donorMap.set(phoneNumber, {
          donor,
          pesanPersonal,
        });
      }

      if (recipients.length === 0) {
        swal("Info", "Tidak ada nomor HP yang valid untuk dikirim", "info");
        setSendingWhatsApp(false);
        return;
      }

      // Update progress awal
      setProgressWhatsApp({ current: 0, total: recipients.length });

      // Kirim semua pesan sekaligus menggunakan API V2
      try {
        console.log("Mengirim multiple pesan via API V2:", {
          recipientCount: recipients.length,
        });

        // Update progress: sedang mengirim
        recipients.forEach((_, index) => {
          const phoneNumber = recipients[index].phone;
          const donorData = donorMap.get(phoneNumber);
          if (donorData) {
            const detailItem = {
              nama: donorData.donor.nama || "-",
              noHp: donorData.donor.noHp || "-",
              pesan: donorData.pesanPersonal,
              status: "Mengirim...",
              response: "",
            };
            setDetailPengiriman((prev) => [...prev, detailItem]);
          }
        });

        // Kirim melalui backend endpoint untuk multiple send (API V2)
        const response = await axios.post(
          `${API_DONOR_DARAH}wablas/send-multiple-message`,
          {
            recipients: recipients,
          },
          {
            timeout: 60000, // 60 detik untuk multiple send
          }
        );

        console.log("Response dari backend (API V2):", {
          status: response.status,
          data: response.data,
        });

        // Update progress: selesai
        setProgressWhatsApp({
          current: recipients.length,
          total: recipients.length,
        });

        // Proses hasil pengiriman
        if (response.data?.success === 1) {
          // Parse hasil per-pesan dari backend
          const results = response.data?.results || [];

          // Jika ada hasil per-pesan, gunakan itu
          if (results.length > 0) {
            results.forEach((result) => {
              const phoneNumber = result.phone;
              const donorData = donorMap.get(phoneNumber);

              if (donorData) {
                const isSuccess = result.status === "success";
                const statusForDB = isSuccess ? "berhasil" : "gagal";
                const statusDisplay = isSuccess ? "Berhasil" : "Gagal";
                const responseMessage =
                  result.message ||
                  (isSuccess
                    ? "Pesan berhasil dikirim"
                    : "Gagal mengirim pesan");

                if (isSuccess) {
                  successCount++;
                } else {
                  failCount++;
                }

                // Update detail di state
                setDetailPengiriman((prev) => {
                  const updated = [...prev];
                  const index = updated.findIndex(
                    (item) => item.noHp === donorData.donor.noHp
                  );
                  if (index !== -1) {
                    updated[index] = {
                      ...updated[index],
                      status: statusDisplay,
                      response: responseMessage,
                    };
                  }
                  return updated;
                });

                // Simpan ke array untuk database
                detailPengirimanForDB.push({
                  data_donor_id: donorData.donor.id || null,
                  nomor_hp: phoneNumber,
                  nama_pendonor: donorData.donor.nama || null,
                  pesan: donorData.pesanPersonal,
                  status: statusForDB,
                  response_message: responseMessage,
                });
              }
            });

            console.log(
              `✅ Pengiriman selesai. Berhasil: ${successCount}, Gagal: ${failCount}`
            );
          } else {
            // Fallback: jika tidak ada hasil per-pesan, gunakan data umum
            const generalSuccess =
              response.data?.successCount > 0 ||
              response.data?.successCount === undefined;

            if (generalSuccess) {
              successCount = response.data?.successCount || recipients.length;
              failCount = response.data?.failCount || 0;

              recipients.forEach((recipient) => {
                const phoneNumber = recipient.phone;
                const donorData = donorMap.get(phoneNumber);
                if (donorData) {
                  const statusForDB = "berhasil";
                  const responseMessage =
                    response.data?.message || "Pesan berhasil dikirim";

                  // Update detail di state
                  setDetailPengiriman((prev) => {
                    const updated = [...prev];
                    const index = updated.findIndex(
                      (item) => item.noHp === donorData.donor.noHp
                    );
                    if (index !== -1) {
                      updated[index] = {
                        ...updated[index],
                        status: "Berhasil",
                        response: responseMessage,
                      };
                    }
                    return updated;
                  });

                  // Simpan ke array untuk database
                  detailPengirimanForDB.push({
                    data_donor_id: donorData.donor.id || null,
                    nomor_hp: phoneNumber,
                    nama_pendonor: donorData.donor.nama || null,
                    pesan: donorData.pesanPersonal,
                    status: statusForDB,
                    response_message: responseMessage,
                  });
                }
              });
            } else {
              failCount = recipients.length;
              successCount = 0;

              const errorMessage =
                response.data?.message || "Gagal mengirim pesan";

              recipients.forEach((recipient) => {
                const phoneNumber = recipient.phone;
                const donorData = donorMap.get(phoneNumber);
                if (donorData) {
                  const statusForDB = "gagal";

                  // Update detail di state
                  setDetailPengiriman((prev) => {
                    const updated = [...prev];
                    const index = updated.findIndex(
                      (item) => item.noHp === donorData.donor.noHp
                    );
                    if (index !== -1) {
                      updated[index] = {
                        ...updated[index],
                        status: "Gagal",
                        response: errorMessage,
                      };
                    }
                    return updated;
                  });

                  // Simpan ke array untuk database
                  detailPengirimanForDB.push({
                    data_donor_id: donorData.donor.id || null,
                    nomor_hp: phoneNumber,
                    nama_pendonor: donorData.donor.nama || null,
                    pesan: donorData.pesanPersonal,
                    status: statusForDB,
                    response_message: errorMessage,
                  });
                }
              });
            }
          }
        } else {
          // Gagal semua
          failCount = recipients.length;
          successCount = 0;

          const errorMessage = response.data?.message || "Gagal mengirim pesan";

          // Update detail pengiriman
          recipients.forEach((recipient) => {
            const phoneNumber = recipient.phone;
            const donorData = donorMap.get(phoneNumber);
            if (donorData) {
              const statusForDB = "gagal";

              // Update detail di state
              setDetailPengiriman((prev) => {
                const updated = [...prev];
                const index = updated.findIndex(
                  (item) => item.noHp === donorData.donor.noHp
                );
                if (index !== -1) {
                  updated[index] = {
                    ...updated[index],
                    status: "Gagal",
                    response: errorMessage,
                  };
                }
                return updated;
              });

              // Simpan ke array untuk database
              detailPengirimanForDB.push({
                data_donor_id: donorData.donor.id || null,
                nomor_hp: phoneNumber,
                nama_pendonor: donorData.donor.nama || null,
                pesan: donorData.pesanPersonal,
                status: statusForDB,
                response_message: errorMessage,
              });
            }
          });

          console.error(`❌ Gagal mengirim semua pesan:`, response.data);
        }
      } catch (error) {
        // Error saat mengirim
        failCount = recipients.length;
        successCount = 0;

        let errorMessage = "Terjadi kesalahan saat mengirim pesan";
        if (error.response) {
          errorMessage =
            error.response.data?.message ||
            error.response.statusText ||
            "Gagal mengirim pesan";
          console.error("Error response:", error.response.data);
        } else if (error.request) {
          errorMessage = "Tidak ada response dari server";
          console.error("Error request:", error.request);
        } else {
          errorMessage = error.message || "Terjadi kesalahan";
          console.error("Error:", error.message);
        }

        // Update detail pengiriman untuk semua
        recipients.forEach((recipient) => {
          const phoneNumber = recipient.phone;
          const donorData = donorMap.get(phoneNumber);
          if (donorData) {
            const statusForDB = "error";

            // Update detail di state
            setDetailPengiriman((prev) => {
              const updated = [...prev];
              const index = updated.findIndex(
                (item) => item.noHp === donorData.donor.noHp
              );
              if (index !== -1) {
                updated[index] = {
                  ...updated[index],
                  status: "Error",
                  response: errorMessage,
                };
              }
              return updated;
            });

            // Simpan ke array untuk database
            detailPengirimanForDB.push({
              data_donor_id: donorData.donor.id || null,
              nomor_hp: phoneNumber,
              nama_pendonor: donorData.donor.nama || null,
              pesan: donorData.pesanPersonal,
              status: statusForDB,
              response_message: errorMessage,
            });
          }
        });

        // Update progress
        setProgressWhatsApp({
          current: recipients.length,
          total: recipients.length,
        });
      }

      setSendingWhatsApp(false);
      setProgressWhatsApp({ current: 0, total: 0 });

      // Simpan data pengiriman ke database untuk batch ini
      if (!cancelSendingRef.current && detailPengirimanForDB.length > 0) {
        try {
          const saveResponse = await axios.post(
            `${API_DONOR_DARAH}pengiriman-pesan`,
            {
              edukasi_id: selectedEdukasi?.id || null,
              jenis_pesan: "edukasi",
              created_by:
                (currentUser && typeof currentUser === "object"
                  ? currentUser.uid
                  : null) || null,
              total_pendonor: detailPengirimanForDB.length,
              details: detailPengirimanForDB,
            },
            {
              timeout: API_TIMEOUT,
            }
          );

          if (saveResponse.data?.success === 1) {
            console.log(
              `✅ Data pengiriman batch ${
                batchIndex + 1
              } berhasil disimpan ke database`
            );
          } else {
            console.error(
              "❌ Gagal menyimpan data pengiriman:",
              saveResponse.data?.message
            );
          }
        } catch (error) {
          console.error(
            "❌ Error menyimpan data pengiriman ke database:",
            error
          );
          // Tidak tampilkan error ke user, karena pengiriman pesan sudah selesai
        }
      }

      // Cek apakah masih ada batch berikutnya (gunakan batches lokal)
      const hasNextBatch = batchIndex + 1 < batches.length;

      // Tampilkan hasil dan opsi untuk melanjutkan
      if (!cancelSendingRef.current) {
        if (hasNextBatch) {
          // Masih ada batch berikutnya, tanyakan apakah ingin melanjutkan
          const continueSending = await swal({
            title: `Batch ${batchIndex + 1} Selesai`,
            text: `Batch ${batchIndex + 1}/${
              batches.length
            } selesai. Berhasil: ${successCount}, Gagal: ${failCount}. Apakah ingin melanjutkan ke batch ${
              batchIndex + 2
            }?`,
            icon: "info",
            buttons: {
              cancel: "Berhenti",
              confirm: "Lanjutkan",
            },
          });

          if (continueSending) {
            // Lanjutkan ke batch berikutnya
            setCurrentBatchIndex(batchIndex + 1);
            await kirimWhatsApp(batchIndex + 1, true, batches);
            return;
          } else {
            // User memilih berhenti - modal tetap terbuka agar user bisa lihat detail
            swal(
              "Pengiriman Dihentikan",
              `Batch ${batchIndex + 1}/${
                batches.length
              } telah dikirim. Berhasil: ${successCount}, Gagal: ${failCount}\n\nModal tetap terbuka untuk melihat detail pengiriman.`,
              "info"
            );
          }
        } else {
          // Semua batch selesai - modal tetap terbuka agar user bisa lihat detail
          const totalSent = successCount + failCount;

          if (successCount > 0 && failCount === 0) {
            // Semua berhasil
            swal(
              "Berhasil! ✅",
              `Semua pesan berhasil dikirim!\n\nTotal: ${totalSent} pendonor\nBerhasil: ${successCount}\nGagal: ${failCount}\n\nModal tetap terbuka untuk melihat detail pengiriman.`,
              "success"
            );
          } else if (successCount > 0 && failCount > 0) {
            // Sebagian berhasil
            swal(
              "Pengiriman Selesai ⚠️",
              `Pengiriman selesai dengan hasil:\n\nTotal: ${totalSent} pendonor\n✅ Berhasil: ${successCount}\n❌ Gagal: ${failCount}\n\nSilakan cek detail pengiriman di tabel di bawah ini.`,
              "warning"
            );
          } else {
            // Semua gagal
            swal(
              "Gagal ❌",
              `Gagal mengirim pesan ke semua pendonor.\n\nTotal: ${totalSent} pendonor\nBerhasil: ${successCount}\nGagal: ${failCount}\n\nSilakan cek detail pengiriman di tabel di bawah ini.`,
              "error"
            );
          }
        }
      } else {
        cancelSendingRef.current = false;
      }
    } catch (error) {
      console.error("Error di kirimWhatsApp:", error);
      setSendingWhatsApp(false);
      swal(
        "Error",
        "Terjadi kesalahan saat mengirim pesan: " +
          (error.message || "Unknown error"),
        "error"
      );
    }
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="6">
            <Card>
              <CardHeader>
                <h5 className="title">
                  {isEditMode ? "Edit Pesan Edukasi" : "Tambah Pesan Edukasi"}
                </h5>
              </CardHeader>
              <CardBody>
                <Form>
                  <Row>
                    <Col md="12">
                      <FormGroup>
                        <label>Topik Edukasi</label>
                        <Input
                          placeholder="Contoh: Manfaat Donor Darah, Syarat Donor Darah, dll"
                          type="text"
                          value={topik}
                          onChange={(e) => setTopik(e.target.value)}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <FormGroup>
                        <label>Judul Pesan</label>
                        <Input
                          placeholder="Judul pesan edukasi"
                          type="text"
                          value={judul}
                          onChange={(e) => setJudul(e.target.value)}
                          required
                        />
                      </FormGroup>
                    </Col>

                    <Col md="12">
                      <FormGroup>
                        <label>Isi Pesan</label>
                        <Input
                          type="textarea"
                          rows={10}
                          value={isiPesan}
                          onChange={(e) => setIsiPesan(e.target.value)}
                          placeholder="Isi pesan edukasi yang akan dikirim ke pendonor..."
                          required
                        />
                        <small className="form-text text-muted">
                          Pesan akan otomatis ditambahkan header menyapa nama
                          pendonor, link aplikasi, dan footer dari sistem.
                        </small>
                      </FormGroup>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
              <CardFooter>
                <Button
                  className="btn-fill"
                  color="primary"
                  onClick={simpanEdukasi}
                >
                  {isEditMode ? "Update" : "Simpan"}
                </Button>
                {isEditMode && (
                  <Button
                    className="btn-fill"
                    color="secondary"
                    onClick={resetForm}
                    style={{ marginLeft: "10px" }}
                  >
                    Batal
                  </Button>
                )}
              </CardFooter>
            </Card>
          </Col>

          <Col md="6">
            <Card>
              <CardHeader>
                <h5 className="title">Daftar Pesan Edukasi</h5>
              </CardHeader>
              <CardBody>
                {listEdukasi.length > 0 ? (
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Topik</th>
                        <th>Judul</th>
                        <th>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listEdukasi.map((item) => (
                        <tr key={item.id}>
                          <td>{item.topik}</td>
                          <td>{item.judul}</td>
                          <td>
                            <Button
                              size="sm"
                              color="info"
                              onClick={() => handleEdit(item)}
                              style={{ marginRight: "5px" }}
                            >
                              <i className="fas fa-edit" />
                            </Button>
                            <Button
                              size="sm"
                              color="success"
                              onClick={() => {
                                setSelectedEdukasi(item);
                                setModalPilihGoldaOpen(true);
                              }}
                              style={{ marginRight: "5px" }}
                            >
                              <i className="fab fa-whatsapp" />
                            </Button>
                            <Button
                              size="sm"
                              color="danger"
                              onClick={() => handleDelete(item.id)}
                            >
                              <i className="fas fa-trash" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                ) : (
                  <p>Tidak ada pesan edukasi. Silakan tambah pesan baru.</p>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Pilih Golongan Darah */}
        <Modal
          isOpen={modalPilihGoldaOpen}
          toggle={() => {
            setModalPilihGoldaOpen(false);
            setSelectedGolda("");
          }}
        >
          <ModalHeader
            toggle={() => {
              setModalPilihGoldaOpen(false);
              setSelectedGolda("");
            }}
          >
            Pilih Golongan Darah
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                <strong>Pilih Golongan Darah:</strong>
              </Label>
              <Input
                type="select"
                value={selectedGolda}
                onChange={(e) => setSelectedGolda(e.target.value)}
              >
                <option value="">-pilih golongan darah-</option>
                {listGolda.map((item) => (
                  <option key={item.bloodTypeID} value={item.bloodTypeID}>
                    {item.golonganDarah}
                  </option>
                ))}
              </Input>
              <small className="form-text text-muted">
                Pesan akan dikirim ke semua pendonor dengan golongan darah yang
                dipilih
              </small>
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button
              color="secondary"
              onClick={() => {
                setModalPilihGoldaOpen(false);
                setSelectedGolda("");
              }}
            >
              Batal
            </Button>
            <Button
              color="primary"
              onClick={() => {
                if (!selectedGolda) {
                  swal(
                    "Info",
                    "Silakan pilih golongan darah terlebih dahulu",
                    "info"
                  );
                  return;
                }
                setModalPilihGoldaOpen(false);
                ambilPendonorDanTampilkanModal(selectedEdukasi, selectedGolda);
              }}
            >
              Lanjutkan
            </Button>
          </ModalFooter>
        </Modal>

        {/* Modal Konfirmasi WhatsApp */}
        <Modal
          isOpen={modalWhatsAppOpen}
          toggle={() => {
            if (!sendingWhatsApp) {
              setModalWhatsAppOpen(false);
              setDetailPengiriman([]); // Kosongkan tabel progress saat modal ditutup
            }
          }}
          size="lg"
        >
          <ModalHeader
            toggle={() => {
              if (!sendingWhatsApp) {
                setModalWhatsAppOpen(false);
                setDetailPengiriman([]); // Kosongkan tabel progress saat modal ditutup
              }
            }}
          >
            <h5
              style={{
                margin: 0,
                fontSize: "1.1rem",
                fontWeight: "500",
              }}
            >
              Konfirmasi Pengiriman Pesan Edukasi WhatsApp
            </h5>
          </ModalHeader>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "15px 24px",
              borderBottom: "1px solid #e9ecef",
              backgroundColor: "#f8f9fa",
            }}
          >
            <div>
              {sendingWhatsApp ? (
                <Button color="danger" size="sm" onClick={handleCancelSending}>
                  Batalkan Pengiriman
                </Button>
              ) : (
                <Button
                  color="secondary"
                  size="sm"
                  onClick={() => {
                    setModalWhatsAppOpen(false);
                    setDetailPengiriman([]);
                    setSelectedGolda("");
                    setSelectedGoldaName("");
                  }}
                >
                  Batal
                </Button>
              )}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {sendingWhatsApp && (
                <span style={{ color: "#666", marginRight: "10px" }}>
                  Mengirim... ({progressWhatsApp.current}/
                  {progressWhatsApp.total})
                </span>
              )}
              {!sendingWhatsApp && (
                <Button
                  color="success"
                  size="sm"
                  onClick={() => {
                    console.log("Tombol Kirim Pesan WhatsApp diklik");
                    kirimWhatsApp();
                  }}
                  disabled={listPendonor.length === 0}
                >
                  <i
                    className="fab fa-whatsapp"
                    style={{ marginRight: "5px" }}
                  />
                  Kirim Pesan WhatsApp
                </Button>
              )}
            </div>
          </div>
          <ModalBody>
            <div>
              {!sendingWhatsApp && selectedEdukasi && (
                <>
                  <h5>Detail Pesan Edukasi:</h5>
                  <Table bordered size="sm">
                    <tbody>
                      <tr>
                        <td>
                          <strong>Topik:</strong>
                        </td>
                        <td>{selectedEdukasi.topik}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Judul:</strong>
                        </td>
                        <td>{selectedEdukasi.judul}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Golongan Darah:</strong>
                        </td>
                        <td>{selectedGoldaName}</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Target Pendonor:</strong>
                        </td>
                        <td>
                          <Badge color="primary">
                            {listPendonor.length} pendonor
                          </Badge>
                        </td>
                      </tr>
                    </tbody>
                  </Table>

                  <h5 style={{ marginTop: 20 }}>Preview Pesan:</h5>
                  <div
                    style={{
                      padding: "15px",
                      background: "#f8f9fa",
                      borderRadius: "5px",
                      fontSize: "0.9rem",
                      whiteSpace: "pre-wrap",
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    {draftPesan.replace(
                      /Halo \*\[Nama Pendonor\]\*,/g,
                      "Halo *[Nama Pendonor]*,"
                    )}
                  </div>
                </>
              )}

              {sendingWhatsApp && (
                <div style={{ marginTop: 20, marginBottom: 20 }}>
                  <h5>Progress Pengiriman:</h5>
                  {batchProgress.total > 1 && (
                    <div style={{ marginBottom: 10 }}>
                      <strong>
                        Batch: {batchProgress.current} / {batchProgress.total}
                      </strong>
                    </div>
                  )}
                  <Progress
                    value={
                      (progressWhatsApp.current / progressWhatsApp.total) * 100
                    }
                    color="success"
                    style={{ height: "25px" }}
                  >
                    {progressWhatsApp.current} / {progressWhatsApp.total} pesan
                    terkirim
                  </Progress>
                </div>
              )}

              {/* Tampilkan progress dan tabel hanya setelah pengiriman dimulai */}
              {(sendingWhatsApp || detailPengiriman.length > 0) && (
                <>
                  <h5 style={{ marginTop: 20 }}>Progress Pengiriman Pesan</h5>
                  <div
                    style={{
                      maxHeight: "400px",
                      overflowY: "auto",
                      border: "1px solid #dee2e6",
                      borderRadius: "5px",
                      padding: "10px",
                    }}
                  >
                    {detailPengiriman.length > 0 ? (
                      <Table size="sm" bordered>
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Nama</th>
                            <th>No. HP</th>
                            <th>Pesan</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {detailPengiriman.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.nama}</td>
                              <td>{item.noHp}</td>
                              <td>
                                <div
                                  style={{
                                    maxWidth: "300px",
                                    maxHeight: "100px",
                                    overflow: "auto",
                                    fontSize: "0.8rem",
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {item.pesan}
                                </div>
                              </td>
                              <td>
                                {item.status === "Berhasil" ? (
                                  <Badge color="success">{item.status}</Badge>
                                ) : item.status === "Gagal" ||
                                  item.status === "Error" ? (
                                  <Badge color="danger">{item.status}</Badge>
                                ) : (
                                  <Badge color="warning">{item.status}</Badge>
                                )}
                                {item.response && (
                                  <div
                                    style={{
                                      fontSize: "0.75rem",
                                      color: "#666",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {item.response}
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : null}
                  </div>
                </>
              )}
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}

export default EdukasiPendonor;
